module.exports = __webpack_public_path__ + "media/images/about-logo-nwtf-bd5c335b7b17ad2c862f330fb51bae79.png";